import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

const ActionCountIcon = ({ icon, color, count, onClick, ...other }) => {
  const cls = ["action-icon"];

  if (onClick) {
    cls.push("link");
  }

  return (
    <div className={classNames(cls)} onClick={onClick} {...other}>
      <div className="action-icon-content">
        <FontAwesomeIcon
          className="icon"
          icon={icon}
          style={{
            color: color,
          }}
        />
        <div className="count">{count}</div>
      </div>
    </div>
  );
};

ActionCountIcon.defaultProps = {
  color: "#4f4f4f",
};
ActionCountIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  color: PropTypes.string,
  count: PropTypes.number.isRequired,
};
export default ActionCountIcon;
